export const makeBlankSwitch = () => ({
  UOS: '',
  switchName: '',
  heatingSys: '',
  gasType: '',
  selectedSSR: [],
  application: '',
  switchSize: '',
  ssrRating: '',
  sysId: '',
  deviceName: null,
  zoneId: null,
  deviceMac: null,
  type: null,
  latitude: null,
  longitude: null,
  displaySelectBox: [false, false, false, false, false, false],
});

export const resizeSwitches = (switches, numSwitches, makeBlank) => {
  if (numSwitches < switches.length) {
    return switches.slice(0, numSwitches);
  }

  const resized = [...switches];
  const numToAdd = numSwitches - resized.length;
  for (let i = 0; i < numToAdd; i++) {
    resized.push(makeBlank());
  }
  return resized;
};
